<template>
  <div :style="{backgroundColor: getCssColor('icon_labels_bg')}">
    <div v-show="banners.length" id="banners_container" class="banner" >
      <template v-if="action">
        <a @click="callToAction()">
        <img :src="banner" alt="banner">
        <div style="clear:both;width:100%;"></div>
        </a>
      </template>
      <template v-else>
        <img :src="banner" alt="banner">
        <div style="clear:both;width:100%;"></div>
      </template>
      <div style="clear:both;width:100%;"></div>
    </div>
    <div v-if="banners.length > 1" style="overflow:none;width:100%;text-align:center;height:20px;margin-top:5px;">
      <div style="display:inline-flex;margin:0 auto;">
        <div 
          @click="fixBanner(bidx)"
          class="bullet_change"
          :style="{opacity:getBulletOpacity(bidx)}" 
          v-for="(b, bidx) in banners" v-bind:key="bidx" 
          ></div>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
import colors from '@/mixins/colors'
import swipe from '@/mixins/swipe'

export default {
  name: 'Banners',
  
  data () {
    return {
      banners: [],
      banner: null,
      action: null,
      idx: 0,
      bannerInverval: null,
      bannerTime: 10000
    }
  },

  mixins: [navigation, colors, swipe],

  methods: {
    bannerPath (idx) {
      if (this.$mq === 'mobile' && this.banners[idx].xs_url) {
        return this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].xs_url
      } else if (this.$mq === 'tablet' && this.banners[idx].sm_url) {
        return this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].sm_url
      } else if (this.banners[idx].md_url) {
        return this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].md_url
      } else {
        return (this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].md_url || this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].sm_url || this.$store.getters.getImgPathBanner + '/banner/' + this.banners[idx].xs_url)
      }
    },

    fixBanner (idx) {
      clearInterval(this.bannerInverval)
      this.bannerInverval = null
      this.idx = idx
      if (this.banners[this.idx] && this.banners[this.idx].call_to_action) {
        this.action = this.banners[this.idx].call_to_action
      }
      this.banner = this.bannerPath(this.idx)
      this.bannerInverval = setInterval(this.updateBanner, this.bannerTime)
    },

    updateBanner () {
      if (this.banners.length) {
        if (this.idx < this.banners.length -1) {
          this.idx++
          this.action = this.banners[this.idx].call_to_action
          this.banner = this.bannerPath(this.idx)
        } else {
          this.action = this.banners[0].call_to_action
          this.banner = this.bannerPath(0)
          this.idx = 0
        }
      }
    },

    callToAction () {
      this.gotToPath(this.action)
    },

    backBanner () {
      clearInterval(this.bannerInverval)
      this.bannerInverval = null
      if (this.idx > 1) {
        this.idx = this.idx - 2
      } else if (this.idx === 1 && this.banners.length > 1) {
        this.idx = this.banners.length - 1
      } else if (this.idx === 0 && this.banners.length > 2) {
        this.idx = this.banners.length - 2
      }
      this.updateBanner()
      this.bannerInverval = setInterval(this.updateBanner, this.bannerTime)
    },

    forwardBanner () {
      clearInterval(this.bannerInverval)
      this.bannerInverval = null
      this.updateBanner()
      this.bannerInverval = setInterval(this.updateBanner, this.bannerTime)
    },

    getBulletOpacity (bidx) {
      if(bidx === this.idx){
        return 1
      } else {
        return 0.5
      }
    },

    swipeBanner (direction) {
      //console.log(direction)
      if (direction === 'right'){
        this.backBanner()
      } else if (direction === 'left') {
        this.forwardBanner()
      }
    }
  },

  mounted () {
    if (!this.$store.state.choicedCompany) {
      if (this.$store.getters.getBanners) {
        this.banners = this.$store.getters.getBanners
      }
    } else {
      if (this.$store.getters.getBannersChild) {
        this.banners = this.$store.getters.getBannersChild
      }
    }

    if (this.banners.length) {
      this.updateBanner()
      this.bannerInverval = setInterval(this.updateBanner, this.bannerTime)
      this.addSwipeListener('banners_container', this.swipeBanner)
    }
  },

  destroyed () {
    clearInterval(this.bannerInverval)
    this.bannerInverval = null
  }

}
</script>

<style lang="scss" scoped>
@import "@/css/_variables.scss";


.banner {
  overflow:hidden;
  position:relative;
  text-align:center;
  
  @media screen and (max-width: $mobile) {
    min-height:250px;
  }
    @media screen and (min-width: $mobile) {
    min-height:400px;
  }
  @media screen and (min-width: $tablet) {
    min-height: 500px;
  }

  

  
  img {

    overflow:none;
    width: 100%;
    height: auto;
    
  }
}

.bullet_change {
    cursor:pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.50);
    background-color:#ffffff;
    margin: 0px 8px; 
    @media screen and (max-width: $mobile) {
      width:16px;
      height:16px;
      border-radius:8px;
    }
    @media screen and (min-width: $mobile) {
      width:20px;
      height:20px;
      border-radius:10px;
    }
    @media screen and (min-width: $tablet) {
      width:20px;
      height:20px;
      border-radius:10px;
    }
  }
</style>
